module.exports = __webpack_public_path__ + "static/TheUnderground_3160x1000-c072eb07ffcc2959ae4cd9544c9ac096.png";